var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { SdsContextMenuItem } from '../../context-menu/item/sds-cm-item.lit';
import styles from '../item/sds-breadcrumbs-item.lit.scss';
import { sdsCustomElement } from '../../utilities/custom-components';
let SdsBreadcrumbsDropdown = (() => {
    var _SdsBreadcrumbsDropdown_label_accessor_storage, _SdsBreadcrumbsDropdown_href_accessor_storage, _SdsBreadcrumbsDropdown_opened_accessor_storage, _SdsBreadcrumbsDropdown_disabled_accessor_storage, _SdsBreadcrumbsDropdown_overflowButton_accessor_storage, _SdsBreadcrumbsDropdown__menu_accessor_storage, _SdsBreadcrumbsDropdown__trigger_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-breadcrumbs-dropdown')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _href_decorators;
    let _href_initializers = [];
    let _href_extraInitializers = [];
    let _opened_decorators;
    let _opened_initializers = [];
    let _opened_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _overflowButton_decorators;
    let _overflowButton_initializers = [];
    let _overflowButton_extraInitializers = [];
    let __menu_decorators;
    let __menu_initializers = [];
    let __menu_extraInitializers = [];
    let __trigger_decorators;
    let __trigger_initializers = [];
    let __trigger_extraInitializers = [];
    var SdsBreadcrumbsDropdown = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsBreadcrumbsDropdown_label_accessor_storage.set(this, __runInitializers(this, _label_initializers, ''));
            _SdsBreadcrumbsDropdown_href_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _href_initializers, '')));
            _SdsBreadcrumbsDropdown_opened_accessor_storage.set(this, (__runInitializers(this, _href_extraInitializers), __runInitializers(this, _opened_initializers, false)));
            _SdsBreadcrumbsDropdown_disabled_accessor_storage.set(this, (__runInitializers(this, _opened_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsBreadcrumbsDropdown_overflowButton_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _overflowButton_initializers, false)));
            _SdsBreadcrumbsDropdown__menu_accessor_storage.set(this, (__runInitializers(this, _overflowButton_extraInitializers), __runInitializers(this, __menu_initializers, void 0)));
            _SdsBreadcrumbsDropdown__trigger_accessor_storage.set(this, (__runInitializers(this, __menu_extraInitializers), __runInitializers(this, __trigger_initializers, void 0)));
            this.toggleContextMenu = (__runInitializers(this, __trigger_extraInitializers), (event) => {
                event.stopPropagation();
                this.opened ? this.closeContextMenu() : this.openContextMenu();
                this.dispatchDropdownToggled();
            });
            this.contextMenuSelectHandler = (event) => {
                if (event.target instanceof SdsContextMenuItem) {
                    this.dispatchDropdownItemSelected(event.target);
                }
                this.closeContextMenu();
                event.stopPropagation();
            };
            this.documentClickHandler = (event) => {
                if (event.target !== this._trigger) {
                    this.closeContextMenu();
                }
            };
        }
        /**
         * The text displayed on the component.
         *
         * @attr {string} label - The label text to display.
         * @default ''
         */
        get label() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown_label_accessor_storage, value, "f"); }
        /**
         * The URL the component links to, if applicable.
         *
         * @attr {string} href - The hyperlink reference for navigation.
         * @default ''
         */
        get href() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown_href_accessor_storage, "f"); }
        set href(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown_href_accessor_storage, value, "f"); }
        /**
         * Controls whether the component is open or collapsed.
         *
         * @attr {boolean} opened - Determines if the component is in the opened state.
         * @default false
         */
        get opened() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown_opened_accessor_storage, "f"); }
        set opened(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown_opened_accessor_storage, value, "f"); }
        /**
         * Disables the component, preventing user interaction.
         *
         * @attr {boolean} disabled - Indicates if the component is disabled.
         * @default false
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown_disabled_accessor_storage, value, "f"); }
        /**
         * Indicates if the component acts as an overflow button.
         * Useful in cases where space is limited.
         *
         * @attr {boolean} overflow-button - Determines if the component behaves as an overflow button.
         * @default false
         */
        get overflowButton() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown_overflowButton_accessor_storage, "f"); }
        set overflowButton(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown_overflowButton_accessor_storage, value, "f"); }
        get _menu() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown__menu_accessor_storage, "f"); }
        set _menu(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown__menu_accessor_storage, value, "f"); }
        get _trigger() { return __classPrivateFieldGet(this, _SdsBreadcrumbsDropdown__trigger_accessor_storage, "f"); }
        set _trigger(value) { __classPrivateFieldSet(this, _SdsBreadcrumbsDropdown__trigger_accessor_storage, value, "f"); }
        render() {
            return html `
            ${this.renderDropdown()}
            <sds-context-menu position="below">
                <slot></slot>
            </sds-context-menu>
        `;
        }
        closeContextMenu() {
            if (this.opened) {
                this._menu.hide();
                this.opened = false;
                this.removeContextMenuSelectHandler();
                this.removeDocumentClickEvent();
            }
        }
        connectedCallback() {
            if (!this.hasAttribute('role')) {
                this.setAttribute('role', 'listitem');
            }
            super.connectedCallback();
            this.closeContextMenu();
        }
        disconnectedCallback() {
            super.disconnectedCallback();
            this.closeContextMenu();
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        renderArrowIcon() {
            return html `
            <sds-button
                id="trigger"
                class="sds-breadcrumbs-item-dropdown"
                type="secondary"
                size="sm"
                icon="${this.opened ? 'arrow_up_small' : 'arrow_down_small'}"
                ?selected="${this.opened}"
                @click="${this.toggleContextMenu}"
            ></sds-button>
            <span
                part="sds-breadcrumbs-item-separator"
                class="sds-breadcrumbs-item-separator"
                aria-hidden="true"
                >/</span
            >
        `;
        }
        renderDropdown() {
            if (this.overflowButton) {
                return html `<sds-button
                    id="trigger"
                    @click="${this.toggleContextMenu}"
                    ?disabled="${this.disabled}"
                    type="secondary"
                    size="sm"
                    icon="more"
                    ?selected="${this.opened}"
                    breadcrumbs
                ></sds-button>
                <span
                    part="sds-breadcrumbs-item-separator"
                    class="sds-breadcrumbs-item-separator"
                    aria-hidden="true"
                    >/</span
                >`;
            }
            else {
                return html `
                <style>
                    sds-breadcrumbs-item::part(sds-breadcrumbs-item-separator) {
                        display: none;
                    }
                </style>
                <sds-breadcrumbs-item
                    class="sds-breadcrumbs-item"
                    ?disabled="${this.disabled}"
                    href="${this.href}"
                    label="${this.label}"
                >
                </sds-breadcrumbs-item>

                ${this.renderArrowIcon()}
            `;
            }
        }
        openContextMenu() {
            this._menu.show(this._trigger);
            this._menu.getMenu().style.width = '160px';
            this.opened = true;
            this.addContextMenuSelectHandler();
            setTimeout(() => this.addDocumentClickEvent());
        }
        addContextMenuSelectHandler() {
            this._menu.getMenu().addEventListener('click', this.contextMenuSelectHandler);
        }
        removeContextMenuSelectHandler() {
            this._menu.getMenu().removeEventListener('click', this.contextMenuSelectHandler);
        }
        dispatchDropdownItemSelected(item) {
            this.dispatchEvent(new CustomEvent(SdsBreadcrumbsDropdown.BREADCRUMBS_DROPDOWN_ITEM_SELECTED, {
                detail: {
                    item: item,
                },
                bubbles: true,
            }));
        }
        dispatchDropdownToggled() {
            this.dispatchEvent(new CustomEvent(SdsBreadcrumbsDropdown.BREADCRUMBS_DROPDOWN_TOGGLED, {
                detail: {
                    item: undefined,
                },
                bubbles: true,
            }));
        }
        addDocumentClickEvent() {
            document.addEventListener('click', this.documentClickHandler);
            document.addEventListener(SdsBreadcrumbsDropdown.BREADCRUMBS_DROPDOWN_TOGGLED, this.documentClickHandler);
        }
        removeDocumentClickEvent() {
            document.removeEventListener('click', this.documentClickHandler);
            document.removeEventListener(SdsBreadcrumbsDropdown.BREADCRUMBS_DROPDOWN_TOGGLED, this.documentClickHandler);
        }
    };
    _SdsBreadcrumbsDropdown_label_accessor_storage = new WeakMap();
    _SdsBreadcrumbsDropdown_href_accessor_storage = new WeakMap();
    _SdsBreadcrumbsDropdown_opened_accessor_storage = new WeakMap();
    _SdsBreadcrumbsDropdown_disabled_accessor_storage = new WeakMap();
    _SdsBreadcrumbsDropdown_overflowButton_accessor_storage = new WeakMap();
    _SdsBreadcrumbsDropdown__menu_accessor_storage = new WeakMap();
    _SdsBreadcrumbsDropdown__trigger_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsBreadcrumbsDropdown");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _label_decorators = [property({ type: String })];
        _href_decorators = [property({ type: String })];
        _opened_decorators = [property({ type: Boolean })];
        _disabled_decorators = [property({ type: Boolean })];
        _overflowButton_decorators = [property({ type: Boolean, attribute: 'overflow-button' })];
        __menu_decorators = [query('sds-context-menu')];
        __trigger_decorators = [query('#trigger')];
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(_classThis, null, _href_decorators, { kind: "accessor", name: "href", static: false, private: false, access: { has: obj => "href" in obj, get: obj => obj.href, set: (obj, value) => { obj.href = value; } }, metadata: _metadata }, _href_initializers, _href_extraInitializers);
        __esDecorate(_classThis, null, _opened_decorators, { kind: "accessor", name: "opened", static: false, private: false, access: { has: obj => "opened" in obj, get: obj => obj.opened, set: (obj, value) => { obj.opened = value; } }, metadata: _metadata }, _opened_initializers, _opened_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _overflowButton_decorators, { kind: "accessor", name: "overflowButton", static: false, private: false, access: { has: obj => "overflowButton" in obj, get: obj => obj.overflowButton, set: (obj, value) => { obj.overflowButton = value; } }, metadata: _metadata }, _overflowButton_initializers, _overflowButton_extraInitializers);
        __esDecorate(_classThis, null, __menu_decorators, { kind: "accessor", name: "_menu", static: false, private: false, access: { has: obj => "_menu" in obj, get: obj => obj._menu, set: (obj, value) => { obj._menu = value; } }, metadata: _metadata }, __menu_initializers, __menu_extraInitializers);
        __esDecorate(_classThis, null, __trigger_decorators, { kind: "accessor", name: "_trigger", static: false, private: false, access: { has: obj => "_trigger" in obj, get: obj => obj._trigger, set: (obj, value) => { obj._trigger = value; } }, metadata: _metadata }, __trigger_initializers, __trigger_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsBreadcrumbsDropdown = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.styles = styles;
    _classThis.BREADCRUMBS_DROPDOWN_ITEM_SELECTED = 'sds.breadcrumbs_dropdown_item.selected';
    _classThis.BREADCRUMBS_DROPDOWN_TOGGLED = 'sds.breadcrumbs_dropdown_item.selected';
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsBreadcrumbsDropdown = _classThis;
})();
export { SdsBreadcrumbsDropdown };
